import firebase from 'firebase/app';

const firebaseDefault = firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
});

const firebaseWebsite = firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_WEBSITE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_WEBSITE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_WEBSITE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_WEBSITE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_WEBSITE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_WEBSITE_MESSAGING_SENDER_ID,
}, 'coal-website');

export { firebaseDefault, firebaseWebsite };
